import React from 'react';
import { render } from 'react-dom';
import './styles/index.css';
import reportWebVitals from './reportWebVitals';
import Auth from './Auth';

render(<Auth />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
